import { createStructuredSelector } from 'reselect';

import { applicantTypeSelector } from '../../store/applicant/selectors';
import { completeSTEP1Selector } from '../../store/step/selectors';

const structuredSelector = createStructuredSelector({
  applicantType: applicantTypeSelector,
  completeSTEP1: completeSTEP1Selector
});

export default structuredSelector;
